import React from 'react';
import { ClientEvent, ClientEventData } from '../helpers/GoFormzAnalytics-types';
import { ForPersonalIcon_Light, ForWorkIcon_Light, MyClientsIcon_Light, MyselfIcon_Light, MyTeamIcon_Light } from './icons';

export type Survey = {
  [page: number]: SurveyQuestion;
};

export type SurveyQuestion = {
  title?: string;
  subTitle?: string;
  /** The delay to wait before moving onto the next question */
  delay: number;
  className?: string;
  trackEvent?: string;
  trackAs?: string;
  trackGoFormzEvent?: ClientEvent;
  answers?: SurveyAnswer[];
  last?: boolean;
  skippable?: boolean;
  multiSelect?: boolean;
};

export type SurveyAnswer = {
  answer: string;
  segmentAnswer?: string;
  icon?: JSX.Element | string;
  description?: string;
  key: ClientEventData;
};

export const survey: Survey = {
  1: {
    className: 'first',
    title: 'How will you use GoFormz?',
    trackEvent: 'GoFormz Intent',
    trackAs: 'Intent',
    trackGoFormzEvent: ClientEvent.OnboardingGoFormzIntent,
    delay: 500,
    answers: [
      {
        answer: 'For work',
        segmentAnswer: 'Business use',
        description: 'Create digital forms and automated processes for my team.',
        icon: <ForWorkIcon_Light />,
        key: ClientEventData.OnboardingGoFormzIntent_Business
      },
      {
        answer: 'For personal use',
        segmentAnswer: 'Personal use',
        description: 'I need to fill out and send forms.',
        icon: <ForPersonalIcon_Light />,
        key: ClientEventData.OnboardingGoFormzIntent_Personal
      }
    ]
  },
  2: {
    className: 'second',
    title: 'Who is going to fill out your forms?',
    trackEvent: `Who's Filling Out Forms`,
    trackAs: 'Answer',
    trackGoFormzEvent: ClientEvent.OnboardingWhosFillingForms,
    delay: 500,
    answers: [
      { answer: 'My team', icon: <MyTeamIcon_Light />, key: ClientEventData.OnboardingWhosFillingForms_Team },
      { answer: 'My clients', segmentAnswer: 'My customers', icon: <MyClientsIcon_Light />, key: ClientEventData.OnboardingWhosFillingForms_Customers },
      { answer: 'Myself', icon: <MyselfIcon_Light />, key: ClientEventData.OnboardingWhosFillingForms_Myself }
    ]
  },
  3: {
    className: 'third',
    delay: 100,
    last: true
  }
};
